import React from 'react'
import AppBar from '../Components/AppBar';
import '../css/login.css'
import myImage from '../../SVG/LoginCenfotec.svg'
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom'
import autService from '../../services/authService'
import WebApi from '../../Api/WebApi'
import OperationStatus from '../../config/OperationStatus'
import LoadingSpiner from '../../Components/LoadingSpiner'
import { getLoginPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { useEffect, useState } from "react";
import { Skeleton } from "antd";
import { StrapiError } from './StrapiError';


import { useValidation } from "../../Hooks/useValidation";
export default function Login() {
  const { validation } = useValidation();
    const { locale } = useLocale();
    const [loginPage, setloginPage] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isLoadingContent, setIsLoadingContent] = useState(true);
    const [hasError, setHasError] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onSubmit = async (data) => {
        setLoading(true)
        let res = await autService.login(data, dispatch)
        if (res.operationStatus === OperationStatus.SUCCESS) {

            localStorage.setItem("token", res.result.token);
            localStorage.setItem("refreshToken", JSON.stringify(res.result.refreshToken));

            WebApi.setAuthToken(res.result.token);
            navigate("/");
        } else {
            setLoading(false)
            toast.error(res.message);
        }
    }

    useEffect(() => {
        let cancel = false;
        setHasError(false);
        setIsLoadingContent(true);
        
        // Timeout para evitar carga eterna
        const timeoutId = setTimeout(() => {
          if (!cancel) {
            setloginPage(null);
            setIsLoadingContent(false);
            setHasError(locale === 'en');
          }
        }, 5000);

        getLoginPage(locale)
          .then((res) => {
            clearTimeout(timeoutId);
            const data = res?.data?.attributes || res?.data || res;
            if (!cancel) {
              setloginPage(data);
              setIsLoadingContent(false);
            }
          })
          .catch((error) => { 
            clearTimeout(timeoutId);
            if (!cancel) {
              setloginPage(null);
              setIsLoadingContent(false);
              // Solo mostrar error si el idioma es inglés
              setHasError(locale === 'en');
            }
          });
        return () => { 
          cancel = true;
          clearTimeout(timeoutId);
        };
      }, [locale])

    if (isLoadingContent) {
      return (
        <div className='rootLogin'>
          <AppBar />
          <div className="loginContainer">
            <div className="grid-container col-2 col-md col-sm-12">
              <div className="grid-item justify-self-center login-item">
                <Skeleton.Input style={{ width: 300, height: 40 }} active />
                <Skeleton.Input style={{ width: 200, height: 30 }} active />
                <div className="form-group">
                  <Skeleton.Input style={{ width: 150, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className="form-group">
                  <Skeleton.Input style={{ width: 120, height: 20 }} active />
                  <Skeleton.Input style={{ width: '100%', height: 40 }} active />
                </div>
                <div className='loginFlex'>
                  <Skeleton.Button style={{ width: 150, height: 40 }} active />
                </div>
                <div className="links">
                  <Skeleton.Input style={{ width: 250, height: 20 }} active />
                  <Skeleton.Input style={{ width: 200, height: 20 }} active />
                  <Skeleton.Input style={{ width: 180, height: 20 }} active />
                </div>
              </div>
              <div className="grid-item justify-self-center reverse login-item">
                <Skeleton.Image style={{ width: 400, height: 400 }} active />
              </div>
            </div>
          </div>
        </div>
      );
    }else if (hasError && locale === 'en') {
      return <StrapiError 
        onRetry={() => {
          setHasError(false);
          setIsLoadingContent(true);
        }}
        onUseDefault={() => {
          setHasError(false);
          setIsLoadingContent(false);
          setloginPage(null);
        }}
      />
    }

    return (
        <div className='rootLogin'>
            <AppBar />

            <div className="loginContainer">
                <div className="grid-container col-2 col-md col-sm-12 ">
                    <div className="grid-item justify-self-center login-item">
                        <h1>{loginPage?.title || "CENFOTEC Admisiones"}</h1>
                        <h2>{loginPage?.subtitle || "Inicio de sesión"}</h2>
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <div className="form-group">
                                <label>{loginPage?.label_email || "Correo electrónico"}</label>
                                <input className="form-control login-input" type="text" placeholder="Juan@gmail.com" {...register("correo", { required: validation?.required_field || "Campo requerido" })} />
                                {errors.correo && <p className="error">{errors.correo.message}</p>}
                            </div>
                            <div className="form-group login-input">
                                <label>{loginPage?.label_password || "Contraseña"}</label>
                                <input className="form-control" type="password" autoComplete="on" placeholder={loginPage?.label_password || "Contraseña"} {...register("contrasena", { required: validation?.required_field || "Campo requerido" })} name="contrasena" />
                                {errors.contrasena && <p className="error">{errors.contrasena.message}</p>}
                            </div>


                            <div className='loginFlex'>
                                <input type="submit" id="btnInicioSesion" value={loginPage?.login_button || "Iniciar sesión"} />
                                {loading &&
                                    <div className="ml-1">
                                        <LoadingSpiner
                                            styles={{
                                                "width": "25px",
                                                "height": "25px",
                                                "border": "6px solid #bbbbbb",
                                                'borderTop': "6px solid #035cc9",
                                            }} />
                                    </div>
                                }
                            </div>
                        </form>

                        <div className="links">
                            <h5><Link to="/RecuperarContrasena" >{loginPage?.forgot_password || "¿Has olvidado la contraseña?"}</Link></h5>
                            <h5>{loginPage?.label_admin || "Soy administrador"} - <Link to="/LoginAdm">{loginPage?.click_here || "Accede aquí"}</Link></h5>
                            <h5>{loginPage?.label_question || "¿No tienes cuenta?"} <Link to="/Registro">{loginPage?.sign_up || "Regístrate"}</Link></h5>
                        </div>
                    </div>
                    <div className="grid-item justify-self-center reverse login-item">
                        <img className="img-login" src={myImage} alt="Imagen de inicio de sesión" />

                    </div>

                </div>
            </div>

        </div>
    )
}
